import axios from "../axios";
import { BASE_URL } from "../Utils";

const LOCATION_URL = "/user-location";

export function updateUserLocation(data) {
    return axios({
        "url": `${BASE_URL}${LOCATION_URL}`,
        "method": "post",
        data,
        hideLoader: true
    });
}

export function removeUserCoordinate(onDuty, coords) {
  let url = `${BASE_URL}${LOCATION_URL}/duty?onDuty=${onDuty}`;
  if (coords?.lat != null && coords?.lng != null) {
    url += `&lat=${coords.lat}&lng=${coords.lng}`;
  }
  return axios({
    "url": url,
    "method": "patch",
  });
}
// CLAUDE-SYNC: v1.7.12 — break tracking. Behaves like clock in/out.
// v1.7.15 — optional lat/lng, same best-effort pattern as duty toggle.
export function patchBreakStatus(onBreak, lat, lng) {
  const coordsQS = (lat != null && lng != null) ? `&lat=${lat}&lng=${lng}` : '';
  return axios({
    "url": `${BASE_URL}${LOCATION_URL}/break?onBreak=${onBreak}${coordsQS}`,
    "method": "patch",
  });
}
